/**
 * Validates an email address format.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} Returns true if the email format is valid, otherwise false.
 */
const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export default validateEmail;
